exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel{min-width:400px}.robin-wrapper{display:flex;flex-direction:column;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:850px;border-radius:10px;background-color:#fff;overflow:hidden;box-shadow:0 30px 18px -24px rgba(0,0,0,.2)}.container2{display:flex;flex-direction:row;justify-content:space-between;padding:25px}.matchup-container{display:flex;flex-direction:column}.pairing button{min-width:150px;margin:2px}.tag{margin-right:10px}.top2{background:rgba(6,245,6,.432)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-89302782","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RoundRobin.vue
// module id = 28
// module chunks = 0